<template>
  <div class="category-main">
    <ebsn-style :target="category" path="category_advanced.CSS_STYLE" />
    <category-block
      :target="category"
      :category-id="category.categoryId"
      position="position1"
      class="category-block category-block-1"
    />

    <div class="category-header">
      <CategoryTitle
        v-if="
          !$ebsn.meta(category, 'category_info.OVERLAYED_HEADER_IMAGE', true)
        "
        :category="category"
        :count="count"
        :selectedCategory="selectedCategory"
      />
      <template v-else>
        <div class="category-title">
          <v-img
            :src="$ebsn.meta(category, 'category_info.HEADER_IMAGE')"
            cover
            onerror="this.onerror=null;this.src='/no-icon.png'"
            height="170px"
          >
            <ebsn-meta
              class="pt-16 text-center main-category-title"
              :target="category"
              path="category_info.TITLE"
              :default-value="category.name"
              tag="h1"
              :style="{ color: $ebsn.meta(category, 'category_info.COLOR') }"
            ></ebsn-meta>
            <!-- <div class="category-description">
              <ebsn-meta
                class="SUBTITLE"
                :target="category"
                path="category_info.SUBTITLE"
                tag="h3"
                @click="clicked"
              ></ebsn-meta>
              <ebsn-meta
                class="description"
                :target="category"
                path="category_info.DESCRIPTION"
                tag="p"
                @click="clicked"
              ></ebsn-meta>
            </div> -->
          </v-img>
        </div>
      </template>
    </div>
    <v-container>
      <Breadcrumb :items="breadcrumb" />

      <!-- <CategoryMainSlider
        :categories="category.children"
        :key="category.categoryId"
        paginationClass="subcategory"
      /> -->
      <template>
        <div class="products">
          <v-container>
            <v-row class="mb-8">
              <v-col
                v-for="subCategory in category.children"
                :key="subCategory.id"
                cols="6"
                sm="6"
                lg="3"
              >
                <v-card
                  class="proposal-card d-flex flex-column justify-space-around align-center"
                  rounded="sm"
                  flat
                  :to="{
                    name: 'Category',
                    params: { pathMatch: subCategory.slug }
                  }"
                >
                  <v-img
                    :src="
                      subCategory.metaData?.category_info?.ICON
                        ? subCategory.metaData?.category_info?.ICON
                        : '/no-image-grey.png'
                    "
                    :alt="subCategory.name"
                    width="170"
                    height="170"
                  />
                  <v-card-text
                    class="pre-slide-text align-center"
                    v-html="subCategory.name"
                  ></v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
          <div class="secondary product-slider-wrapper">
            <ProductListSlider
              :layout="25"
              :categoryId="category.categoryId"
              :promo="true"
              :title="'In promozione in ' + category.name"
              :paginationClass="'swiper-pagination-promo'"
              class="secondary"
              position="category_main_i_piu_venduti"
            />
          </div>
          <div class="grey lighten-2 product-slider-wrapper">
            <ProductListSlider
              :layout="27"
              :categoryId="category.categoryId"
              :title="'I più venduti in ' + category.name"
              :paginationClass="'swiper-pagination-venduti'"
              position="category_main_in_promozione"
            />
          </div>
        </div>
      </template>
    </v-container>
    <category-block
      :target="category"
      :category-id="category.categoryId"
      position="position2"
      class="category-block category-block-2"
    />
    <category-block
      :target="category"
      :category-id="category.categoryId"
      position="position3"
      class="category-block category-block-3"
    />

    <v-container>
      <ebsn-meta
        :target="category"
        path="category_info.FOOTER_DESCRIPTION"
        tag="div"
      />
    </v-container>
  </div>
</template>
<style lang="scss">
.category-main {
  .center-img {
    margin-right: auto;
    margin-left: auto;
  }
  .pre-slide-text {
    width: initial;
    text-align: center;
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: 0px;
    text-align: center;
    color: #3a3a3a;
    text-transform: uppercase;
  }
  .category-header {
    h3 {
      line-height: 0.9;
      line-height: 1.2;
    }
    .category-description {
      position: absolute;
      right: 20px;
      background: #fff;
      top: 40px;
      width: 45%;
      padding: 30px;
      @media #{map-get($display-breakpoints, 'xs-only')} {
        top: 30x;
        padding: 0;
      }
    }
  }
}
</style>
<script>
// @ is an alias to /src
// import CategoryTitle from "@/components/category/CategoryTitle.vue";
// import CategoryMainSlider from "@/components/category/CategoryMainSlider.vue";
import Breadcrumb from "@/components/navigation/Breadcrumb.vue";
// import CategoryBlock from "@/components/categoryBlock/CategoryBlock.vue";

import categoryMixins from "~/mixins/category";

import get from "lodash/get";
import clickHandler from "~/mixins/clickHandler";

export default {
  name: "CategoryMain",
  mixins: [categoryMixins, clickHandler],
  data() {
    return {
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 20,
        watchOverflow: true,
        pagination: {
          el: ".firstCategory",

          clickable: true
        }
      },
      count: -1
    };
  },
  components: {
    // CategoryTitle,
    // CategoryMainSlider,
    Breadcrumb
    // ,
    // CategoryBlock
  },
  methods: {
    updateCount(count) {
      this.count = count;
    }
  },
  metaInfo() {
    return {
      title: get(
        this.category,
        "metaData.category_seo.SEO_TITLE",
        this.category ? this.category.name : ""
      ),
      meta: [
        {
          vmid: "description",
          name: "description",
          content: get(
            this.category,
            "metaData.category_seo.SEO_DESCRIPTION",
            this.$t("meta.category.firstLevel.description", [
              this.category.name
            ])
          )
        },
        // Open Graph Metas
        {
          vmid: "og:locale",
          property: "og:locale",
          content: "it_IT"
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: get(
            this.category,
            "metaData.category_seo.SEO_TITLE",
            this.category ? this.category.name : ""
          )
        },
        {
          vmid: "og:type",
          property: "og:type",
          content: "product.group"
        },
        {
          vmid: "og:url",
          property: "og:url",
          content: location.href
        },
        {
          vmid: "og:image",
          property: "og:image",
          content:
            "https://" + window.location.host + global.config.socialLogo ||
            "/logo/social-logo.png"
        },
        {
          vmid: "og:image:alt",
          property: "og:image:alt",
          content: get(
            this.category,
            "metaData.category_seo.SEO_DESCRIPTION",
            this.$t("meta.category.firstLevel.description", [
              this.category.name
            ])
          )
        },
        {
          vmid: "og:site_name",
          property: "og:site_name",
          content: "Grosmarket.it"
        },
        // Twitter Metas
        {
          vmid: "twitter:card",
          name: "twitter:card",
          content: "summary_large_image"
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          content: get(
            this.category,
            "metaData.category_seo.SEO_TITLE",
            this.category ? this.category.name : ""
          )
        },
        {
          vmid: "twitter:image",
          name: "twitter:image",
          content:
            "https://" + window.location.host + global.config.socialLogo ||
            "/logo/social-logo.png"
        },
        {
          vmid: "twitter:url",
          name: "twitter:url",
          content: location.href
        }
      ]
    };
  }
};
</script>
